import React, { Component } from "react";
import { Select, Spin } from "antd";
import axios from "axios";

const { Option } = Select;

// Selección única de usuario (SelectUsuariosItem.js ya existente es mode="multiple",
// no sirve para un campo tipo "Responsable"). Mismo endpoint, mismo contrato de
// respuesta (usuarios/selectUsuariosEmpresa regresa el array directo, sin {success}).
class SelectUsuarioItem extends Component {
  state = { opciones: [], cargando: false };

  componentDidMount() {
    this.cargarUsuarios();
  }

  cargarUsuarios = () => {
    const { headersToken, empresaId } = this.props;
    if (!empresaId) return;
    this.setState({ cargando: true });
    axios
      .post("usuarios/selectUsuariosEmpresa", { empresaId }, { headers: headersToken })
      .then((res) => {
        if (Array.isArray(res.data)) this.setState({ opciones: res.data });
      })
      .catch(() => {})
      .finally(() => this.setState({ cargando: false }));
  };

  render() {
    const { empresaId, headersToken, ...rest } = this.props;
    return (
      <Select
        showSearch
        allowClear
        loading={this.state.cargando}
        filterOption={(input, opt) => opt.children.toLowerCase().includes(input.toLowerCase())}
        notFoundContent={this.state.cargando ? <Spin size="small" /> : "Sin resultados"}
        {...rest}
      >
        {this.state.opciones.map((usuario) => (
          <Option key={usuario._id} value={usuario._id}>
            {`${usuario.nombre} ${usuario.apellidoPaterno ?? ""}`.trim()}
          </Option>
        ))}
      </Select>
    );
  }
}

export default SelectUsuarioItem;
